
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Spinner,
  TabPane,
  Table,
  FormGroup, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";
import { validateToken, has_Permission } from '../../../helpers/jwt-token-access/accessToken'
import { AvForm, AvField } from "availity-reactstrap-validation";
import classnames from "classnames";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { BaseUrl } from "../../../helpers/Baseurl";
import { isEmpty } from "lodash";

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { Dates, Months, months_name } from '../../../helpers/methods'

import default_img from '../../../assets/images/noimg.jpeg'

const customStyles = {
  overlay: {
      marginTop: '70px'
  }
}


class VehicleDetailPage extends Component {
  constructor(props) {
    super(props);
    this.obj = this.props.obj
    if (this.props.obj){
        if (!validateToken(this.props.obj.access)){
          this.props.history.push('/logout')
        }  
      }
    this.state = {
      isFits:false,
      images : [],
      images_name :[],
      photoIndex:0,
      activeTab: 1,
      activeDescriptionTab: "specifications",
      vehicle: {},
      prices:[],
      pricing_id:"",
      bank_detail:[],
    
      selectedStartMonth: { label: "Jan", value: 1 },
      selectedEndMonth: { label: "Jan", value: 1 },
      selectedStartDate: { label: "1", value: '1' },
      selectedEndDate: { label: "1", value: '1' },
    };

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
    }

    this.toggleTab = this.toggleTab.bind(this);
    this.toggledescription = this.toggledescription.bind(this);
    this.imageShow = this.imageShow.bind(this);
    this.tog_AddSeason = this.tog_AddSeason.bind(this);
    this.tog_EditSeason = this.tog_EditSeason.bind(this);
    this.tog_edit_bank_detail = this.tog_edit_bank_detail.bind(this)
    this.handleSeasonSubmit = this.handleSeasonSubmit.bind(this);
    this.handleEditSeasonSubmit = this.handleEditSeasonSubmit.bind(this);
    this.handleBankDetailSubmit = this.handleBankDetailSubmit.bind(this)
  }

  async loadData(){
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/vehicles/vehicle/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (response) => {
              document.title = response.vehicle.name+" | Planmans";                        
              this.setState({ vehicle:response.vehicle, prices:response.pricing, seasons:response.seasons })   
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  async loadPaymentDetail(){
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'},
    };
    fetch(`${BaseUrl}/api/vehicles/vehicle-bank-detail/?vehicle__id=${id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => { 
              this.setState({ bank_detail:data.results[0],  loading_bank_detail: false, model_edit_bank_detail:false })    
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
  }

  componentDidMount() {
    this.loadData()
    this.loadPaymentDetail()
    
  }
  tog_AddSeason() {
    this.setState(prevState => ({
      model_AddSeason: !prevState.model_AddSeason
    }));
    this.removeBodyCss();
  }

  tog_EditSeason() {
    this.setState(prevState => ({
      model_EditSeason: !prevState.model_EditSeason
    }));
    this.removeBodyCss();
  }

  tog_edit_bank_detail() {
    this.setState(prevState => ({
        model_edit_bank_detail: !prevState.model_edit_bank_detail
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }


  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggledescription(tab) {
    if (this.state.activeDescriptionTab !== tab) {
      this.setState({
        activeDescriptionTab: tab,
      });
    }
  }

  imageShow(img, id) {
    const expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = img;
  }

  onImageClick(images){
    console.log(images)
    let image = []
    let images_name = []
    for (let i=0; i<images.length; i++){
        image.push(BaseUrl+images[i].image)
        images_name.push(images[i].name)
    }
    this.setState({ isFits: true, photoIndex: 0, images:image, images_name})
  }

  handleSelectedStartMonth = selectedStartMonth => {
    this.setState({ selectedStartMonth });
  }

  handleSelectedEndMonth = selectedEndMonth => {
    this.setState({ selectedEndMonth });
  }

  handleSelectedStartDate = selectedStartDate => {
    this.setState({ selectedStartDate });
  }

  handleSelectedEndDate = selectedEndDate => {
    this.setState({ selectedEndDate });
  }

  handleSeasonSubmit(){
    const {vehicle, selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth} = this.state
    this.setState({addSeasonloading:true})
    let data = {
      "start_date": selectedStartDate.value,
      "start_month": selectedStartMonth.value,
      "end_date": selectedEndDate.value,
      "end_month": selectedEndMonth.value,
      "vehicle": vehicle.id
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/vehicles/vehicle_seasons/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                  toastr.error("Something Went Wrong", "") 
                  this.setState({ addSeasonloading: false })
                }
                else{
                    this.loadData()
                    this.setState({addSeasonloading: false, model_AddSeason:false })
                }    
            }
        )
  }

  handleSeasonDelete = id => {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.props.obj.access}` },
  
      };
        fetch(`${BaseUrl}/api/vehicles/vehicle_seasons/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({
                      pricing_id:"",
                      season_success_confirm: false,
                      season_alert_confirm : false,
                      })
                  }
                  else{
                    this.loadData();
                    this.setState({
                      pricing_id:"",
                      season_success_confirm: true,
                      season_alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Season has been deleted."
                      })
                  }
              }
          )

  }

  handleSeasonEdit = row => {
    let selectedEndDate = { label: row.end_date, value: row.end_date }
    let selectedEndMonth = { label: months_name[row.end_month-1], value: row.end_month }
    let selectedStartDate = { label: row.start_date, value: row.start_date }
    let selectedStartMonth = { label: months_name[row.start_month-1], value: row.start_month }
    this.setState({selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth, model_EditSeason:true, pricing_id:row.id  })

  }

  handleEditSeasonSubmit(){
    const {vehicle, selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth, pricing_id} = this.state
    this.setState({editSeasonloading:true})
    let data = {
      "start_date": selectedStartDate.value,
      "start_month": selectedStartMonth.value,
      "end_date": selectedEndDate.value,
      "end_month": selectedEndMonth.value,
      "vehicle": vehicle.id
    }
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/vehicles/vehicle_seasons/${pricing_id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ editSeasonloading: false, pricing_id:"" })
                        }     
                    )
                }
                else{
                  this.loadData()
                  this.setState({editSeasonloading: false, model_EditSeason:false, pricing_id:"" })
                }    
            }
        )
  }

  // Save Bank Details
  handleBankDetailSubmit(e, values){
    const { bank_detail, vehicle } = this.state
    this.setState({ loading_bank_detail: true })
    let data = {  'bank_name': values.bank_name,
                  'ifsc':values.ifsc,
                  'account_no':values.account_no,
                  'upi':values.upi,
                  'account_name':values.account_name,
                  'branch_name':values.branch_name,
                  'upi_bank_name':values.upi_bank_name,
                  'upi_user_name':values.upi_user_name,
                  'vehicle': vehicle.id,
                 }

    if(bank_detail){
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/vehicles/vehicle-bank-detail/${bank_detail.id}/`,requestOptions)
          .then(res => 
              {if(res.status >= 400){
                  res.json()
                  .then(
                      (data) =>{  
                        console.log(data, "---data")
                        this.setState({ loading_bank_detail: false })
                      }     
                  )
              }
              else{
                this.loadPaymentDetail()
              }    
          }
      )
    }else{
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/vehicles/vehicle-bank-detail/`,requestOptions)
          .then(res => 
              {if(res.status >= 400){
                  res.json()
                  .then(
                      (data) =>{  
                        console.log(data, "---data")
                        this.setState({ loading_bank_detail: false })
                      }
                  )
              }
              else{
                this.loadPaymentDetail()
              }    
          }
      )
    }


  }

  render() {
    const { vehicle, prices, images, photoIndex, images_name, bank_detail } = this.state;
    let breadcrumbItems =  [
      { title: "Vehicles", link: "/vehicles" },
      { title: (vehicle.name? vehicle.name: "Vehicle")+" Detail", link: "#" },
    ]
    return (
      <React.Fragment>
        <div className={this.obj?"page-content":"mt-4"}>
          
          <Container fluid>
          {this.obj?
            <Breadcrumbs
              title={""}
              breadcrumbItems={breadcrumbItems}
            />:
            null}


            {!isEmpty(vehicle)?  (
            
              <React.Fragment>
                {this.state.isFits ? (
                  <Lightbox
                            
                  reactModalStyle = {this.obj?customStyles:""}
                  mainSrc={images[photoIndex]}
                  nextSrc={images[(photoIndex + 1) % images.length]}
                  prevSrc={
                  images[(photoIndex + images.length - 1) % images.length]
                  }
                  enableZoom={false}
                  onCloseRequest={() => this.setState({ isFits: false })}
                  onMovePrevRequest={() =>
                  this.setState({
                      photoIndex: (photoIndex + images.length - 1) % images.length
                  })
                  }
                  onMoveNextRequest={() =>
                  this.setState({
                      photoIndex: (photoIndex + 1) % images.length
                  })
                  }
                  imageCaption={
                        `Image : ${images_name[photoIndex]}`
                      }
                />
                ) : null}
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col xl="5">
                            <div className="vehicle-detail">
                              <Row>
                                <Col xs="3" className="scroll-y">
                                  <Nav className="flex-column" pills>
                                  {vehicle.images.map(
                                          (item, i) => ( 
                                            
                                    <NavItem>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.activeTab === i+1,
                                        })}
                                        onClick={() => {
                                          this.toggleTab(i+1);
                                        }}
                                      >
                                        <img
                                          src={BaseUrl+item.image}
                                          alt={item.name}
                                          onClick={() => {
                                            this.imageShow(BaseUrl+item.image, i+1);
                                          }}
                                          className="img-fluid mx-auto d-block tab-img rounded"
                                        />
                                      </NavLink>
                                    </NavItem>
                                    ))}
                                  </Nav>
                                </Col>
                                <Col xs="9">
                                  <TabContent
                                    activeTab={this.state.activeTab}
                                    className="position-relative"
                                  >
                                     {vehicle.images.length >0?
                                     vehicle.images.map(
                                          (item, i) => (  
                                    <TabPane tabId={i+1}>
                                      <div className="vehicle-img" style={{backgroundColor:"gray", height:"350px"}}>
                                        <img
                                          onClick= {() => this.onImageClick(vehicle.images)}
                                          src={BaseUrl+item.image}
                                          alt=""
                                          id={"expandedImg"+(i+1)}
                                          className="img-fluid mx-auto d-block"
                                          style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                        />
                                      </div>
                                    </TabPane>
                                    )):
                                    <TabPane tabId={1}>
                                      <div className="vehicle-img" style={{backgroundColor:"gray", height:"350px"}}>
                                        <img
                                          src={default_img}
                                          alt=""
                                          id={"expandedImg"+"default_img"}
                                          className="img-fluid mx-auto d-block"
                                          style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                        />
                                      </div>
                                    </TabPane> }
                                  </TabContent>
                                  
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col xl="7">
                            <div className="mt-4 mt-xl-3">
                              <Link to="#" className="text-primary">
                              {vehicle.brand.name}
                              </Link>
                              <h5 className="mt-1 mb-3">{vehicle.name} ({vehicle.model})</h5>

                            
                              <hr className="my-4" />
                              
                              <Row>
                                <Col md="12">
                                  <div>
                                    <h5 className="font-size-14">
                                      <i className="mdi mdi-location"></i>{" "}
                                      Description
                                    </h5>
                                    <p className="mt-3">{vehicle.description}</p>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-4">
                          <h5 className="font-size-14 mb-3">
                            Additional Details:{" "}
                          </h5>
                          <div className="vehicle-desc">
                            <Nav tabs className="nav-tabs-custom">
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active:
                                            this.state.activeDescriptionTab ===
                                            "specifications",
                                        })}
                                        onClick={() => {
                                            this.toggledescription("specifications");
                                        }}
                                        >
                                    Specifications
                                    </NavLink>
                                </NavItem>
                                {this.obj?
                                    <>
                                    <NavItem>
                                    <NavLink
                                    className={classnames({
                                        active:
                                        this.state.activeDescriptionTab ===
                                        "description",
                                    })}
                                    onClick={() => {
                                        this.toggledescription("description");
                                    }}
                                    >
                                    Detail
                                    </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        className={classnames({
                                            active:
                                            this.state.activeDescriptionTab ===
                                            "pricing",
                                        })}
                                        onClick={() => {
                                            this.toggledescription("pricing");
                                        }}
                                        >
                                        Pricing
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                    <NavLink
                                        className={classnames({
                                        active:
                                            this.state.activepricingTab ===
                                            "seasons",
                                        })}
                                        onClick={() => {
                                        this.toggledescription("seasons");
                                        }}
                                    >
                                        Seasons
                                    </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        className={classnames({
                                            active:
                                            this.state.activepricingTab ===
                                            "payment",
                                        })}
                                        onClick={() => {
                                            this.toggledescription("payment");
                                        }}
                                        >
                                        Payment Detail
                                        </NavLink>
                                    </NavItem>
                                    </>:null}
                            </Nav>
                            <TabContent
                              activeTab={this.state.activeDescriptionTab}
                              className="border border-top-0 p-4"
                            >
                              <TabPane tabId="specifications">
                              <div className="table-responsive">
                                  <Table className="table-nowrap mb-0">
                                    <tbody>
                                    <tr key={'name'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Name"}
                                        </th>
                                        <td>{vehicle.name}</td>
                                    </tr>
                                    <tr key={'brand'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Make"}
                                        </th>
                                        <td>{vehicle.brand.name}</td>
                                    </tr>
                                    <tr key={'model'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Model"}
                                        </th>
                                        <td>{vehicle.model}</td>
                                    </tr>
                                    <tr key={'year'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Year"}
                                        </th>
                                        <td>{vehicle.year}</td>
                                    </tr>
                                    <tr key={'type'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Type"}
                                        </th>
                                        <td>{vehicle.vehicle_type.name}</td>
                                    </tr>
                                    <tr key={'fuel'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Fuel"}
                                        </th>
                                        <td>{vehicle.fuel_type}</td>
                                    </tr>
                                    <tr key={'seates'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"No of Seates"}
                                        </th>
                                        <td>{vehicle.seats}</td>
                                    </tr>
                                    <tr key={'mileage'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Mileage"}
                                        </th>
                                        <td>{vehicle.mileage} (km/litre)</td>
                                    </tr>
                                    <tr key={'no'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Vehicle Number"}
                                        </th>
                                        <td>{(vehicle.number).toUpperCase()}</td>
                                    </tr>
                                    <tr key={'ac'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"AC"}
                                        </th>
                                        <td>{vehicle.ac?"YES":"NO"}</td>
                                    </tr>
                                    <tr key={'heater'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Heater"}
                                        </th>
                                        <td>{vehicle.heater?"YES":"NO"}</td>
                                    </tr>
                                    <tr key={'passenger_airbag'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Passenger Airbags"}
                                        </th>
                                        <td>{vehicle.passenger_airbag?"YES":"NO"}</td>
                                    </tr>

                                    </tbody>
                                  </Table>
                                </div>
                              </TabPane>
                              <TabPane tabId="description">
                                <div className="table-responsive">
                                  <Table className="table-nowrap mb-0">
                                    <tbody>
                                    <tr key={'driver_name'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Driver Name"}
                                        </th>
                                        <td>{vehicle.driver_name}</td>
                                    </tr>
                                    <tr key={'mobile_no'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Driver Contact No."}
                                        </th>
                                        <td>{vehicle.mobile_no}</td>
                                    </tr>
                                    <tr key={'agency'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Agency"}
                                        </th>
                                        <td>{vehicle.agency}</td>
                                    </tr>
                                    <tr key={'agency_contact'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Agency Contact No."}
                                        </th>
                                        <td>{vehicle.agency_contact}</td>
                                    </tr>
                                    <tr key={'address'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Agency Address"}
                                        </th>
                                        <td>{vehicle.address}</td>
                                    </tr>
                                    <tr key={'zip_code'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Pin Code"}
                                        </th>
                                        <td>{vehicle.zip_code}</td>
                                    </tr>
                                    <tr key={'destination'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Destination"}
                                        </th>
                                        <td>{vehicle.destination?vehicle.destination.name:""}</td>
                                    </tr>
                                    <tr key={'place'}>
                                        <th
                                        scope="row"
                                        style={{ width: "20%" }}
                                        >
                                        {"Place"}
                                        </th>
                                        <td>{vehicle.place?vehicle.place.name:""}</td>
                                    </tr>
                                   

                                    </tbody>
                                  </Table>
                                </div>
                              </TabPane>
                              <TabPane tabId="pricing">
                                <div className="table-responsive">
                                  <Table className="table-nowrap mb-0">
                                    <tbody>    
                                      <tr key={'PricingHeading'}>
                                          <th
                                          scope="row"
                                          >
                                          {"Package"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"Off Season "}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"On Season"}
                                          </th>
                                          
                                      </tr>                        
                                    {prices.map((price) => {
                                      return (
                                        <tr key={"price"+price.id}>
                                        <th
                                        scope="row"
                                        >
                                        {price?
                                        (price.package.nights === 0 ? `${price.package.days} Day` : `${price.package.days} Days - ${price.package.nights} Nights`)
                                        :''}
                                        </th>
                                        <td>₹ {price.price}</td>
                                        <td>₹ {price.on_season_price}</td>
                                    </tr>
                                      )
                                    })}
                                    </tbody>
                                  </Table>
                                </div>
                              </TabPane>
                              <TabPane tabId="seasons">
                                  <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'SeasonsHeading'}>
                                          <th
                                          scope="row"
                                          >
                                          {"Srart"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"End"}
                                          </th>
                                          {has_Permission(this.obj?.user, 2, 'edit' )|| has_Permission(this.obj?.user, 2, 'delete' )?
                                          <th
                                          scope="row"
                                          >
                                          {"Action"}
                                          </th>
                                          :null}
                                      </tr>
                                      {this.state.seasons.map(
                                          (item, i) => (
                                          <tr key={"season"+i}>
                                            <td>{item.start_date} {months_name[item.start_month-1]}</td>
                                            <td>{item.end_date} {months_name[item.end_month-1]}</td>
                                            <td>
                                            {has_Permission(this.obj?.user, 2, 'edit' )?
                                            <Link to="#" onClick={() => this.handleSeasonEdit(item)}  className="text-primary"><i className="mdi mdi-pencil-outline font-size-18"></i></Link>
                                            :null}
                                            {" "}
                                            {has_Permission(this.obj?.user, 2, 'delete' )?
                                            <Link to="#" onClick={() => this.setState({ season_alert_confirm: true, pricing_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                            :null}
                                            </td>
                                          </tr>
                                          ))}
                                    

                                      </tbody>
                                    </Table>
                                  </div>
                                  {has_Permission(this.obj?.user, 2, 'edit' )?
                                    <Button type="button" className="btn-sm mt-4" onClick={this.tog_AddSeason} color="info"><i className=" fas fa-plus"></i></Button>
                                  :null}
                                  
                              </TabPane>
                              <TabPane tabId="payment">
                                <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'acc_name'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Account Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.account_name:""}</td>
                                      </tr>
                                      <tr key={'acc_number'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Account Number"}
                                          </th>
                                          <td>{bank_detail?bank_detail.account_no:""}</td>
                                      </tr>
                                      <tr key={'bank_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Bank Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.bank_name:""}</td>
                                      </tr>
                                      <tr key={'bank_branch'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Branch"}
                                          </th>
                                          <td>{bank_detail?bank_detail.branch_name:""}</td>
                                      </tr>
                                      <tr key={'acc_ifsc'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"IFSC code"}
                                          </th>
                                          <td>{bank_detail?bank_detail.ifsc:""}</td>
                                      </tr>
                                      <tr key={'upi_bank_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI Bank Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_bank_name:""}</td>
                                      </tr>
                                      <tr key={'upi_user_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI User Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_user_name:""}</td>
                                        </tr>
                                      <tr key={'acc_upi'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi:""}</td>
                                      </tr>
                                      
                                      </tbody>
                                    </Table>
                                </div>
                                {has_Permission(this.obj?.user, 2, 'edit' )?
                                  <Button type="button" className="btn-sm mt-4" onClick={this.tog_edit_bank_detail} color="info"><i className="fas fa-pen"></i></Button>
                                :null}
                                </TabPane>
                            </TabContent>
                          </div>
                        </div>
                        {this.obj?
                          has_Permission(this.obj?.user, 2, 'edit' )?
                          <Button type="button" className="btn-sm mt-4" onClick={() => this.props.history.push(`/edit-vehicle/${vehicle.id}`)} color="info"><i className="fas fa-pen"></i></Button>
                          :null
                        :null}
                        </CardBody>
                    </Card>
                  </Col>
                </Row>
              </React.Fragment>
           
            )
            :
            <div className="d-flex align-items-center justify-content-center min-vh-100">
      
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
      
            </div>}
          </Container>
        </div>
         {/* Add Season */}
         <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_AddSeason}
                toggle={() => this.tog_AddSeason()}
                centered={true}
              >
                <ModalHeader toggle={() => this.setState({ model_AddSeason: false })}>
                Add Season 
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleSeasonSubmit} >
                  <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Date</Label>
                              <Select 
                              value={this.state.selectedStartDate}
                              onChange={this.handleSelectedStartDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Month</Label>
                              <Select 
                              value={this.state.selectedStartMonth}
                              onChange={this.handleSelectedStartMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                    <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Date</Label>
                              <Select 
                              value={this.state.selectedEndDate}
                              onChange={this.handleSelectedEndDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Month</Label>
                              <Select 
                              value={this.state.selectedEndMonth}
                              onChange={this.handleSelectedEndMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                 
          
                                      
                    <FormGroup className="mb-0">
                      {this.state.addSeasonloading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>
        {/* Edit Season */}
        <Col sm={6} md={4} xl={3} className="mt-4">
          
          <Modal
            isOpen={this.state.model_EditSeason}
            toggle={() => {this.tog_EditSeason(); this.setState({ pricing_id:""})}}
            centered={true}
          >
            <ModalHeader toggle={() => {this.tog_EditSeason(); this.setState({ pricing_id:""})}}>
            Edit Season 
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleEditSeasonSubmit} >
              <Row> 
              

                <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">Start Date</Label>
                          <Select 
                          value={this.state.selectedStartDate}
                          onChange={this.handleSelectedStartDate}
                          options={Dates}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col> 
                  <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">Start Month</Label>
                          <Select 
                          value={this.state.selectedStartMonth}
                          onChange={this.handleSelectedStartMonth}
                          options={Months}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col>
                </Row>  
                <Row> 
                <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">End Date</Label>
                          <Select 
                          value={this.state.selectedEndDate}
                          onChange={this.handleSelectedEndDate}
                          options={Dates}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col> 
                  <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">End Month</Label>
                          <Select 
                          value={this.state.selectedEndMonth}
                          onChange={this.handleSelectedEndMonth}
                          options={Months}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col>
                </Row>  
              
      
                                  
                <FormGroup className="mb-0">
                  {this.state.editSeasonloading?(
                    <Spinner className="me-2 mt-2" color="primary" />
                  ):(
                    <div>
                
                  <Button type="submit" color="primary" className="me-1">
                    Submit
                  </Button>
                  </div>
                    )}
                </FormGroup>     
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>
      
        {/* Add/Edit Bank Detail  */}
        <Col sm={6} md={4} xl={3} className="mt-4">    
            <Modal
              isOpen={this.state.model_edit_bank_detail}
              toggle={this.tog_edit_bank_detail}
              centered={true}
            >
              <ModalHeader toggle={this.tog_edit_bank_detail}>
              {bank_detail?"Edit ": "Add "}Payment Detail
              </ModalHeader>
              <ModalBody>
                <AvForm className="needs-validation" onValidSubmit={this.handleBankDetailSubmit} >
                  <h6 className="mb-4">Bank Details </h6>
                  <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="account_name">Account Name</Label>
                            <AvField
                                name="account_name"
                                type="text"
                                placeholder="Account Name"
                                errorMessage="Enter Account Name"
                                className="form-control"
                                value= {bank_detail?.account_name}
                                validate={{ required: { value: true } }}
                                id="account_name"
                                
                            />
                          </div>
                        </Col> 
                        <Col md={6}>
                            <div className="mb-3">
                                <AvField
                                    name="account_no"
                                    label="Account Number"
                                    placeholder="Account Number"
                                    type="number"
                                    value= {bank_detail?.account_no}
                                    errorMessage="Enter Only Digits"
                                    validate={{
                                        required: { value: true },
                                        pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits"
                                        }
                                    }}
                                    />
                            </div>
                        </Col>
                          
                  </Row>   
                  <Row>
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="bank_name">Bank Name</Label>
                          <AvField
                              name="bank_name"
                              placeholder="Bank Name"
                              type="text"
                              errorMessage="Enter Bank Name"
                              className="form-control"
                              value= {bank_detail?.bank_name}
                              validate={{ required: { value: true } }}
                              id="bank_name"
                              
                          />
                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="branch_name">Branch Name</Label>
                          <AvField
                              name="branch_name"
                              type="text"
                              placeholder="Branch Name"
                              errorMessage="Enter Branch Name"
                              className="form-control"
                              value= {bank_detail?.branch_name}
                              validate={{ required: { value: true } }}
                              id="branch_name"
                              
                          />
                          </div>
                      </Col> 
                      
                  </Row>
                  <Row>
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="ifsc">IFSC Code</Label>
                          <AvField
                              name="ifsc"
                              type="text"
                              placeholder="IFSC Code"
                              errorMessage="Enter IFSC Code"
                              value= {bank_detail?.ifsc}
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="ifsc"  
                          />
                          </div>
                      </Col> 
                  </Row>
                  <hr />
                  <h6 className="mb-4">UPI Details </h6>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="form-label " htmlFor="upi_user_name">User Name</Label>
                        <AvField
                          name="upi_user_name"
                          placeholder="User Name"
                          type="text"
                          errorMessage="Enter User Name"
                          className="form-control"
                          value= {bank_detail?.upi_user_name}
                          validate={{ required: { value: true } }}
                          id="upi_user_name"
                            
                        />
                      </div>
                    </Col> 
                    <Col md="6">
                        <div className="mb-3">
                        <Label className="form-label " htmlFor="upi_bank_name">Bank Name</Label>
                        <AvField
                            name="upi_bank_name"
                            placeholder="UPI Bank Name"
                            type="text"
                            errorMessage="Enter Bank Name"
                            className="form-control"
                            value= {bank_detail?.upi_bank_name}
                            validate={{ required: { value: true } }}
                            id="upi_bank_name"
                        />
                        </div>
                    </Col> 
                  </Row>
                  <Row>
                  <Col md="6">
                      <div className="mb-3">
                      <Label className="form-label " htmlFor="upi">UPI ID</Label>
                      <AvField
                          name="upi"
                          type="text"
                          placeholder="UPI"
                          errorMessage="Enter UPI"
                          className="form-control"
                          value= {bank_detail?.upi}
                          validate={{ required: { value: true } }}
                          id="upi"
                      />
                      </div>
                    </Col> 
                  </Row>               
                  <FormGroup className="mb-0">
                    {this.state.loading_bank_detail?(
                      <Spinner className="me-2 mt-2" color="primary" />
                    ):(
                      <div>
                  
                    <Button type="submit" color="primary" className="me-1">
                      Submit
                    </Button>
                    </div>
                      )}
                  </FormGroup>     
                </AvForm>
              </ModalBody>
            </Modal>
        </Col>



          {this.state.season_alert_confirm ? (
              <SweetAlert
              title="Are you sure?"
              warning
              showCancel
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => this.handleSeasonDelete(this.state.pricing_id)}
              onCancel={() =>
                  this.setState({
                    season_alert_confirm: false,
                      pricing_id:"",

                  })
              }
              >
              You won't be able to revert this!
              </SweetAlert>
          ) : null}

          {this.state.season_success_confirm ? (
              <SweetAlert
              success
              title={this.state.dynamic_title}
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => this.setState({ season_success_confirm: false, season_alert_confirm : false,  })}
              >
                  {this.state.dynamic_description}
              </SweetAlert>
          ) : null}

      </React.Fragment>
    );
  }
}


export default VehicleDetailPage ;
